// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'onsenui/css/onsenui.css'
import 'onsenui/css/onsen-css-components.css'


import Vue from 'vue'
import VueOnsen from 'vue-onsenui'
import store from './store'
import App from './App'
import VueI18n from 'vue-i18n'
import messages from  './data/i18n/i18n'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use(VueOnsen)
Vue.use(VueI18n)


const i18n = new VueI18n({
    locale: 'Español', // set locale
    messages,

})
/* eslint-disable no-new */
var app = new Vue({
    el: '#app',
    store,
    i18n,
    template: '<App/>',
    components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js